import { Grid, InputAdornment, TextField, useTheme } from '@material-ui/core'
import { useContext, useState } from 'react'
import { MdEmail } from 'react-icons/md'
import { useLocation, useNavigate } from 'react-router-dom'
import { GlobalContext } from '../../App'
import { login } from '../../components/api.ts'
import PasswordField from '../../components/PasswordField/PasswordField'
import translations from '../../translations'

const Login = ({ setTela, setTelaValidaToken }) => {
  
  const t = translations[navigator.language.split('-')[0].toUpperCase()] || translations['PT'];
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()

  const { verificaLogin } = useContext(GlobalContext)

  const [usuario, setUsuario] = useState('')
  const [senha, setSenha] = useState('')

  const logar = async () => {
    const response = await login(usuario, senha)
    if (response.status) {
      if (response.aguardandoConfEmail) {
        setTelaValidaToken({ open: true, idUsuario: response.idUsuario })
        setTela('cadastro')
      } else {
        document.cookie = `token=${response.token};`
        delete response.status
        verificaLogin(response, navigate, location)
        navigate(response.programa || '/')
      }
    }
  }

  const handleUsuario = (e) => setUsuario(e.target.value)
  const handleSenha = (e) => setSenha(e.target.value)

  const handleEnter = (e) => {
    if (e.key === 'Enter') logar()
  }

  return (
    <>
      <Grid item xs={12}>
        <TextField
          onKeyDown={handleEnter}
          fullWidth
          variant="outlined"
          margin="dense"
          label="Email"
          value={usuario}
          onChange={handleUsuario}
          autoFocus
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <MdEmail fontSize={24} fill={theme.palette.action.active} />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PasswordField
          onKeyDown={handleEnter}
          fullWidth
          variant="outlined"
          margin="dense"
          label={t.senha}
          value={senha}
          onChange={handleSenha}
        />
      </Grid>
      <Grid item xs={12}>
        <button
          className="w-full rounded-md bg-default p-2 text-md  font-sans  text-white transition-opacity hover:opacity-80"
          onClick={logar}
        >
          {t.login}
        </button>
      </Grid>
    </>
  )
}

export default Login
